import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-089b11ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "xdoc-scroller vertical",
  style: {"z-index":"1","display":"flex","flex-direction":"column","flex-grow":"1","position":"relative","margin-right":"0","margin-bottom":"0","overflow":"hidden auto"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"position":"absolute","top":"0","left":"0"} }, [
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_3 = ["onInput"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"height":"1px","width":"1px","caret-color":"transparent"} }, null, -1))
const _hoisted_5 = {
  class: "layout",
  style: {"padding-bottom":"30vh"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "layout-full" }, [
  /*#__PURE__*/_createElementVNode("div", {
    contenteditable: "false",
    class: "pseudoSelection",
    "data-content-editable-void": "true",
    style: {"user-select":"none","--pseudoSelection--background":"transparent","width":"100%","display":"flex","flex-direction":"column","align-items":"center","flex-shrink":"0","flex-grow":"0","z-index":"2"}
  })
], -1))
const _hoisted_7 = { class: "layout-content" }
const _hoisted_8 = { style: {"width":"100%","display":"flex","flex-direction":"column","align-items":"center","flex-shrink":"0","flex-grow":"0"} }
const _hoisted_9 = { style: {"max-width":"100%","padding-left":"calc(0px + env(safe-area-inset-left))","width":"100%"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  contenteditable: "false",
  class: "pseudoSelection",
  "data-content-editable-void": "true",
  style: {"user-select":"none","--pseudoSelection--background":"transparent","pointer-events":"none"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "xdoc-page-controls" })
], -1))
const _hoisted_11 = { style: {"padding-right":"calc(0 + env(safe-area-inset-right))"} }
const _hoisted_12 = ["data-block-id"]
const _hoisted_13 = {
  class: "notranslate",
  spellcheck: "true",
  placeholder: "Untitled",
  "data-content-editable-leaf": "true",
  contenteditable: "true",
  style: {"max-width":"100%","width":"100%","white-space":"pre-wrap","word-break":"break-word","caret-color":"rgb(55, 53, 47)","padding":"3px 2px","font-size":"1em","font-weight":"inherit","margin":"0px"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-left":"4px"} }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-left":"4px"} }, null, -1))
const _hoisted_16 = {
  key: 0,
  class: "layout-content layout-content-with-divider"
}
const _hoisted_17 = {
  contenteditable: "false",
  "data-content-editable-void": "true"
}
const _hoisted_18 = {
  key: 1,
  class: "layout-content layout-content-with-divider"
}
const _hoisted_19 = {
  contenteditable: "false",
  "data-content-editable-void": "true"
}
const _hoisted_20 = {
  class: "layout-content layout-editor",
  style: {"min-height":"170px"}
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"height":"1px","width":"1px","caret-color":"transparent"} }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "xdoc-presence-container",
  style: {"position":"absolute","top":"0","left":"0","z-index":"89"}
}, [
  /*#__PURE__*/_createElementVNode("div")
], -1))

import PageProperties from "@/ui/components/PageProperties.vue";
import PageDiscussion from "@/ui/components/PageDiscussion.vue";
import PageContent from "@/ui/components/PageContent.vue";
import { computed } from 'vue';
import { useRecordValuesStore } from "@/stores/recordValues";
import { syncRecordValueFromApi } from "@/helpers/globals/SyncRecordValueFromApi";
import BaseDataProvider from "./BaseDataProvider.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RenderPage',
  props: {
    blockId: {
        type: String,
        required: true
    }
},
  setup(__props) {

const props = __props

const recordValuesStore = useRecordValuesStore();

const pageRecordValue = recordValuesStore.getRecordValue(
    props.blockId,
    "block",
    "f2cf1fd1-8789-4ddd-9190-49f41966c446"
)

const pageHeadingText = computed(()  => pageRecordValue?.properties?.title?.[0]?.[0]);

const { 
    parent_table: pageParentTable, 
    parent_id: pageParentId,
    discussions,
    content
} = pageRecordValue;

if (pageParentTable === "collection") {
    syncRecordValueFromApi(
        "collection",
        pageParentId,
        "f2cf1fd1-8789-4ddd-9190-49f41966c446"
    )

    content?.forEach((id: string) => {
        syncRecordValueFromApi(
            "block",
            id,
            "f2cf1fd1-8789-4ddd-9190-49f41966c446"
        )
    })
}

function handleInput(e: Event) {    
    console.log(e.target);
}

// const pageDiscussionRecordValueInStore = computed(function() {
//     return recordValuesStore.getRecordValue(
//         pageRecordValue.discussion,
//         "collection",
//         "f2cf1fd1-8789-4ddd-9190-49f41966c446"
//     )?.defer
// })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      onInput: _withModifiers(handleInput, ["stop"]),
      class: "whenContentEditable",
      "data-contenteditable-root": "true",
      style: {"display":"flex","flex-direction":"column","position":"relative","align-items":"center","caret-color":"rgb(55, 53, 47)","width":"100%","flex-grow":"1","--whenContentEditable--WebkitUserModify":"read-write-plaintext-only"}
    }, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", {
                    "data-block-id": props.blockId,
                    class: "xdoc-selectable xdoc-page-block",
                    style: {"color":"rgb(55, 53, 47)","font-weight":"700","line-height":"1.2","font-size":"40px","font-family":"ui-sans-serif, -apple-system, BlinkMacSystemFont,\r\n                                                'Segoe UI', Helvetica, 'Apple Color Emoji', Arial,\r\n                                                sans-serif, 'Segoe UI Emoji', 'Segoe UI Symbol'","cursor":"text","display":"flex","align-items":"center"}
                  }, [
                    _createElementVNode("h1", _hoisted_13, _toDisplayString(pageHeadingText.value), 1),
                    _hoisted_14
                  ], 8, _hoisted_12),
                  _hoisted_15
                ])
              ])
            ])
          ])
        ]),
        (_unref(pageParentTable) === 'collection')
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(PageProperties, {
                  "page-id": props.blockId,
                  "collection-id": _unref(pageParentId)
                }, null, 8, ["page-id", "collection-id"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(pageParentTable) === 'collection')
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(discussions), (discussionId) => {
                  return (_openBlock(), _createBlock(BaseDataProvider, {
                    "block-id": discussionId,
                    "space-id": "f2cf1fd1-8789-4ddd-9190-49f41966c446",
                    table: "discussion",
                    key: discussionId
                  }, {
                    default: _withCtx(({ recordValueDeferInStore }) => [
                      (recordValueDeferInStore === 1)
                        ? (_openBlock(), _createBlock(PageDiscussion, {
                            key: 0,
                            "discussion-id": discussionId
                          }, null, 8, ["discussion-id"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["block-id"]))
                }), 128)),
                (!_unref(discussions)?.length)
                  ? (_openBlock(), _createBlock(PageDiscussion, {
                      key: 0,
                      "page-id": props.blockId
                    }, null, 8, ["page-id"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(PageContent, {
            "block-id": props.blockId,
            "space-id": "f2cf1fd1-8789-4ddd-9190-49f41966c446"
          }, null, 8, ["block-id"])
        ])
      ]),
      _hoisted_21
    ], 40, _hoisted_3),
    _hoisted_22
  ]))
}
}

})